const IsEmptyArray = (array) => {
	return Array.isArray(array) && array.length === 0;
};

export default IsEmptyArray;
